import React, { useEffect, useRef, useState, } from 'react';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import axios from 'axios';
import BackEndUrl from '../../../backURL';
import loading from "../../../Images/three-dots.svg"
import { Row } from 'react-bootstrap';
import { Button } from '@nextui-org/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faExpand } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as FileSaver from 'file-saver';

const backend = BackEndUrl.domain
const DocViewerComp = ( {selectedDataRow} ) => {

  const [urlData, setUrlData] = useState(null)
  const [docs, setDocs] = useState([])
  const [selectedUrl, setSelectedUrl] = useState(null)
  
  useEffect(() => {
    async function getProofDoc() {
      try {
        const response = await axios.post(backend + "/get-proof-doc", {
          id: selectedDataRow?.id
        }, {
          headers: {
            Authorization: sessionStorage.getItem('staff-token'),
          }
        })
        setUrlData(response.data)

      }
      catch (err) {
        console.error(err)
      }
    }
    if (!urlData) {
      getProofDoc()
    }

  }, [urlData, selectedDataRow])

  useEffect(() => {
    if (docs.length === 0) {
      if (urlData) {
        const dataArray = urlData.map((item, index) => ({
          uri: `${backend}${item.url}`,
          fileName: selectedDataRow?.req_type,
        }));
        setDocs((prev) => [...prev, ...dataArray]);
      } 
    }
  }, [selectedDataRow, urlData, docs]);

  useEffect(() => {
    if (!selectedUrl && docs.length > 0) {
      setSelectedUrl(docs[0]?.uri);
    }
  }, [selectedUrl, docs]);


  const handleDownload = () => {
    if (selectedUrl) {

      FileSaver.saveAs(selectedUrl, `${selectedDataRow.id}-${selectedDataRow.nic}`);
    }
  };

  return (
    <div className='d-flex justify-content-center'>
      {urlData ? (
        <>
          {urlData.length > 0 && 
          <> <h2>Proof Documents</h2>
            
              <div style={{ width: "80%" }} className='d-flex flex-row'>
                <DocViewer
                  style={{ height: "100%", width: "100%" }}
                  documents={docs}
                  initialActiveDocument={docs[0]}
                  pluginRenderers={DocViewerRenderers}
                  onDocumentChange={(e)=>{setSelectedUrl(e.uri)}}

                />

                {selectedUrl && <Button onClick={handleDownload} isIconOnly={true}><FontAwesomeIcon icon={faDownload} /></Button>}
                {selectedUrl && <Button className='mx-1' isIconOnly={true}><a href={selectedUrl} target='blank'><FontAwesomeIcon icon={faExpand} /></a></Button>}
              </div>
         
          </>
          }

        </>
      ) : (
        
        <Row>
          <img src={loading} className='m-5' style={{ width: "40%" }} />
        </Row>
      )}
    </div>
  );


};

export default DocViewerComp;
